// Instance
const STATUS_RUNNING = "running";
const STATUS_CHANGING_SUBSCRIPTION_PLAN = "changing-subscription-plan";
const STATUS_CHANGE_REGION = "change-region";
const STATUS_SUSPENDED = "suspended";
const STATUS_DELETING = "deleting";
const STATUS_DELETED = "deleted";
const STATUS_DELETE_FAILED = "delete-failed";
const STATUS_ERROR = "error";

const HEALTH_PROVISIONING = "PROVISIONING";
const HEALTH_HEALTHY = "HEALTHY";
const HEALTH_UNKNOWN = "UNKNOWN";
const HEALTH_UNHEALTHY = "UNHEALTHY";
const HEALTH_DNSFAIL = "DNSFAIL";
const HEALTH_DELETED = "DELETED";

// Purchase
const TOKEN_STATE_TRIAL = "trial";
const TOKEN_STATE_VALID = "valid";
const TOKEN_STATE_EXPIRED = "expired";
const TOKEN_STATE_EXPIRED_TRIAL = "expired-trial";

// Org, users & contract
const STATUS_ACTIVE = "active";
const STATUS_INACTIVE = "inactive";
const STATUS_DRAFT = "draft";
const STATUS_READY = "ready";

// Migration
const MIGRATION_STATUS_INITIALIZED = "initialized";
const MIGRATION_STATUS_SNAPSHOT_UPLOADED = "snapshot-uploaded";
const MIGRATION_STATUS_MIGRATING = "migrating";
const MIGRATION_STATUS_COMPLETED = "completed";
const MIGRATION_STATUS_MIGRATION_FAILED = "migration-failed";

// Status => words
export const HEALTH_TO_HUMAN_WORDS = {
  loading: "Loading...",
  [STATUS_RUNNING]: "Running",
  [STATUS_CHANGE_REGION]: "Changing region",
  [STATUS_CHANGING_SUBSCRIPTION_PLAN]: "Changing plan",
  [STATUS_DELETING]: "Deleting",
  [STATUS_DELETED]: "Deleted",
  [STATUS_SUSPENDED]: "Suspended",
  [STATUS_DELETE_FAILED]: "Deletion failed",
  [STATUS_ERROR]: "An error occurred",
  [HEALTH_PROVISIONING]: "Provisioning...",
  [HEALTH_HEALTHY]: "Running normally",
  [HEALTH_UNKNOWN]: "...",
  [HEALTH_DNSFAIL]: "Having DNS issues",
  [HEALTH_UNHEALTHY]: "Having issues",
  [HEALTH_DELETED]: "Deleted",
  [TOKEN_STATE_TRIAL]: "In trial",
  [TOKEN_STATE_VALID]: "Valid",
  [TOKEN_STATE_EXPIRED]: "Expired",
  [TOKEN_STATE_EXPIRED_TRIAL]: "Trial expired",
  [STATUS_ACTIVE]: "Active",
  [STATUS_INACTIVE]: "Inactive",
  [STATUS_DRAFT]: "Draft",
  [STATUS_READY]: "Ready",
  [MIGRATION_STATUS_INITIALIZED]: "Migration started",
  [MIGRATION_STATUS_SNAPSHOT_UPLOADED]: "Migration in progress",
  [MIGRATION_STATUS_MIGRATING]: "Migration in progress",
  [MIGRATION_STATUS_COMPLETED]: "Migration completed",
  [MIGRATION_STATUS_MIGRATION_FAILED]: "Migration failed",
};

export interface IHealthIndicatorProps {
  health: ColorHexValue | string;
  size?: number;
}
